import { useContext, useEffect, useState } from 'react'
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import Tabs from '../component/Tabs';
import { ConfigContext } from '../Context/ConfigContext';

const Products = () => {
  const locale = localStorage.getItem('lang');
  const {
    gdcURL,
    PCID,
    setCategories,
    categories,
    treeCategories,
    apiB2BURL
  }
    = useContext(ConfigContext);
  const dir = localStorage.getItem('dir');

  const [p_subs, setPsubs] = useState(null);
  const [p_index, setPindex] = useState(0);
  const [p_title, setPTitle] = useState(null);
  const [p_STR_ID, setPSTRID] = useState(null);

  const [loading, setLoading] = useState(true);
  const { s_str_id } = useParams();
  const [stridtree, setSTRIDTree] = useState(s_str_id ? [Number(s_str_id), null] : [null]);

  const [starDepartments, setStartDepartment] = useState([]);
  const [responsive] = useState({
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
      slidesToSlide: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
      slidesToSlide: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2,
      slidesToSlide: 1
    }
  })

  useEffect(() => {
    const fetchCategories = async () => {
      window.scrollTo(0, 0);

      const storedPCID = localStorage.getItem("pc_id");

      try {
        setLoading(true);

        let url = "";

        if (storedPCID && storedPCID !== "" && storedPCID !== "0") {
          url = `${apiB2BURL}/Customer/Parts/GetCategoriesByCar?pc_id=${PCID}&lang=en`;
        } else {
          url = `${apiB2BURL}/Customer/Parts/GetCategories?lang=en`;
        }

        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();

        setCategories(result.data);
      } catch (err) {
        console.error("Category Fetch Error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, [PCID, locale]);



  useEffect(() => {
    var tempstarDepartments = [];
    treeCategories.map((item) => {
      if (item.STR_ID === 100002) {
        tempstarDepartments.push(item);
        if (item.children.length > 0) {
          item.children.map((child) => {
            tempstarDepartments.push(child);
            child.children.map((child2) => {
              tempstarDepartments.push(child2);
            });
          });
        }
      }
    })

    setStartDepartment(tempstarDepartments);
  }, [treeCategories])

  const CategorySkeleton = () => {
    return (
      <div className="p-3 skeleton-card">
        {/* Image skeleton */}
        <div className="skeleton-img mb-3"></div>


        {/* List skeleton */}
        <div className="skeleton-line"></div>
        <div className="skeleton-line"></div>
      </div>
    );
  };



  const car_info = localStorage.getItem('car_info') ? JSON.parse(localStorage.getItem('car_info')) : null;

  const handleShow = (subs, title, STR_ID, index) => {
    setPTitle(title);
    setPsubs(subs);
    setPSTRID(STR_ID);
    setPindex(Math.floor(((index) / 6)));
  }

  const [showAllCategories, setShowAllCategories] = useState(false);

  return (
    <main className="main" style={{ textAlign: dir === 'rtl' ? 'right' : 'unset' }} dir={dir} >

      <div className={'container py-3'} >
        <div className="" >
          {/* {loading ? (
            <Swiper
              spaceBetween={20}
              slidesPerView={5}
              breakpoints={{
                320: { slidesPerView: 1.2 },
                576: { slidesPerView: 2 },
                768: { slidesPerView: 3 },
                1024: { slidesPerView: 5 },
              }}
            >
              {Array.from({ length: 5 }).map((_, i) => (
                <SwiperSlide key={`skeleton-${i}`}>
                  <CategorySkeleton />
                </SwiperSlide>
              ))}
            </Swiper>
          ) : loading === false &&
          categories &&
          categories.length > 0 &&
          treeCategories &&
          treeCategories.length > 0 && (

            <div className={`${treeCategories.length}`}>
              <Swiper
                modules={[Navigation]}
                spaceBetween={20}
                slidesPerView={4}
                navigation={true}
                loop={false}
                breakpoints={{
                  320: { slidesPerView: 1.2 },
                  576: { slidesPerView: 2 },
                  768: { slidesPerView: 3 },
                  1024: { slidesPerView: 5 },
                }}
              >
                {treeCategories.map((item, indexxx) => (
                  item.children && (
                    <SwiperSlide key={item.STR_ID}>
                      <div
                        className={"p-3 mr-4"}
                        style={{
                          backgroundColor: "#f5f5f5",
                          height: "500px",
                          overflow: "hidden"
                        }}
                      >
                        
                        <div style={{ minHeight: "100px" }}>
                          <img
                            src={`${gdcURL}/category-images/600x600/${item.STR_ID}`}
                            className="img-fluid"
                            height={100}
                            alt={item.STR_NODE_NAME}
                            onClick={() =>
                              handleShow(
                                item.children,
                                item.STR_NODE_NAME,
                                item.STR_ID,
                                indexxx
                              )
                            }
                            onError={({ currentTarget }) => {
                              currentTarget.onerror = null;
                              currentTarget.src =
                                "https://placehold.co/100x100/FFFFFF/FFFFFF/png";
                              currentTarget.height = 100;
                            }}
                          />
                        </div>
                        
                        <div style={{ position: "relative" }}>
                          <hr style={{ lineHeight: 0, margin: 0 }} />
                          <div
                            style={{
                              position: "absolute",
                              left: "50%",
                              top: "50%",
                              transform: "translate(-50%, -50%)",
                              width: "8px",
                              height: "8px",
                              borderRadius: "50%",
                              backgroundColor: "#cc000a"
                            }}
                          />
                        </div>
                        
                        <center>
                          <div
                            className="mt-2"
                            style={{
                              fontSize: "15px",
                              fontWeight: "600",
                              color: "#000",
                              height: "50px"
                            }}
                          >
                            {item.STR_NODE_NAME}
                          </div>
                        </center>

                        <br />
                        
                        <ul
                          style={{
                            lineHeight: "25px",
                            listStyleType: "disc",
                            paddingLeft: dir === "rtl" ? "" : "20px",
                            paddingRight: dir === "rtl" ? "20px" : ""
                          }}
                          dir={dir}
                        >
                          {item.children.slice(0, 5).map((child) => (
                            <li key={child.STR_ID} style={{ color: "#cc000a" }}>
                              <NavLink
                                className="nav-link-custom"
                                style={{ color: "#000" }}
                              >
                                {child.STR_NODE_NAME}
                              </NavLink>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </SwiperSlide>
                  )
                ))}
              </Swiper>
            </div>
          )} */}

          {loading === false && categories && categories.length > 0 &&
            <section className="feature-boxes-container" style={{ background: '#FFF' }}>
              <h3 style={{ fontWeight: 500, marginBottom: '20px', marginTop: '30px', fontSize: '40px' }}> GHAYAR ORIGINAL SPARE PARTS CATALOG</h3>
              <div className="container" data-animation-name="fadeInUpShorter" >
                <Tabs p_index={p_index} p_subs={p_subs} p_title={p_title} p_STR_ID={p_STR_ID} />
              </div>
            </section>
          }

          {
            car_info && treeCategories && treeCategories.map((item, indexxx) => {
              if (item.STR_ID === 100002) {
                return <h3 style={{ fontWeight: 500, marginTop: "20px" }}>{`Car Department Catalogue for ${car_info[0].TYPEL} - ${item.STR_NODE_NAME}`}</h3>
              }
            })
          }

          {/* <div className='row'>
            {
              starDepartments && starDepartments.slice(0, showAllCategories ? starDepartments.length : 4).map((child) => (
                <div className='col-sm-3' key={child.STR_ID}>
                  <NavLink
                    className="nav-link-custom"
                    style={{ display: 'flex', alignItems: 'center' }}
                  >
                    <img
                      alt={child.STR_NODE_NAME}
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = "https://placehold.co/100x100/FFFFFF/FFFFFF/png";
                      }}
                      src={`${gdcURL}/category-images/600x600/${child.STR_ID}`}
                      style={{ width: '100px', marginRight: '10px' }} />
                    {child.STR_NODE_NAME}
                  </NavLink>
                </div>
              ))
            }
          </div> */}

          {/* {treeCategories && treeCategories.some(item => item.STR_ID === 100002 && item.children.length > 4) && (
            <div className="text-center mt-3">
              <button
                className="hiring-btn bg-transparent text-danger"
                onClick={() => setShowAllCategories(!showAllCategories)}
                style={{ textDecoration: 'none' }}
              >
                {showAllCategories ? 'Show less' : 'Show more'}
                <i style={{ marginRight: 'unset' }} className={`ri-arrow-${showAllCategories ? 'up' : 'down'}-s-line ms-2`}></i>
              </button>
            </div>
          )} */}

          <br />
        </div>
      </div>
      {/* <div className="mb-5">
        <Brands />
      </div> */}
    </main>

  )

}

export default Products;